module.exports = __webpack_public_path__ + "static/img/zcje.2b08a5a9.png";